var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { Environments, IdmUtilities } from "./Idm-Utility.js";
export class McLogout {
  /** Creates an instance of the McLogout class
   * @param environmentName The environment, local, dev, etc. It will be used later to use specific cookie names instead of MCCheck
   */
  constructor(environmentName) {
    this.environmentName = environmentName;
    this.CookieName = 'MCCheck';
    this.version = "1.3.5";
    /** Number of seconds to wait when calling logout url. If using this Authentication.logout , it can stop waiting when the logouts completes.
     * So this is moslty for legacy apps that register their logout in the MCCheck cookie */
    this.timeout = 5;
    this.resolved = false;
    this.redirectToCookieName = "mx1.logout-redirectTo";
    this.statusChanged = null;
    this.urlAdded = null;
    if (!environmentName["length"]) {
      this.environmentName = Environments[environmentName];
    }
    this.utilities = new IdmUtilities();
    this.CookieName = this.CookieName; //+ "." + this.environmentName;
  }
  //add log out URL in login page or when SSO user deep links to application
  addLogoutUrlToCookie(logoutUrl) {
    var cookieName = this.CookieName;
    this.utilities.writeCookie("mx1.selfLogout", logoutUrl);
    let currentCookie = this.utilities.readCookie(cookieName);
    let urls = [];
    if (currentCookie) {
      urls = currentCookie.split(",");
      if (urls.indexOf(logoutUrl) != -1) return;
    }
    urls.push(logoutUrl);
    let cookieValue = urls.join(",");
    this.utilities.writeCookie(cookieName, cookieValue, null, true);
  }
  sameRootDomain(host1, host2) {
    var index1 = host1.indexOf("/", 8);
    var index2 = host2.indexOf("/", 8);
    if (index1 >= 0) {
      host1 = host1.substring(0, index1 - 1);
    }
    if (index2 >= 0) {
      host2 = host2.substring(0, index2 - 1);
    }
    var parts1 = host1.split(".");
    var parts2 = host2.split(".");
    for (var j = 1; j < parts1.length; j++) {
      if (parts1[j] != parts2[j]) return false;
    }
    return true;
  }
  removeLogoutUrl(url) {
    var cookieName = this.CookieName;
    let currentCookieValue = this.utilities.readCookie(cookieName);
    if (!currentCookieValue) return;
    let urls = currentCookieValue.split(",");
    let index = urls.indexOf(url);
    if (index != -1) urls.splice(index);
    if (urls.length == 0) this.utilities.deleteCookie(cookieName, true);else this.utilities.writeCookie(cookieName, urls.join(","), null, true);
  }
  renderStatusHtml() {
    var styleCode = `
            
            .url {
              font-size: 18px;
            }

            .container-fluid, .row {
                margin-left:2px;
             }

             ul{
                margin-left:5px;
             }

             h2,.h2 {
                font-size: 26px;
                color: #f26522;
            }
            
        `;
    var scriptCode = `
                function addUrl(url) {
                  console.log("adding url to logout " + url);
                  var ul = document.getElementById("uxUrls");
                  var li = document.createElement("li");
                  li.innerText = url;
                  li.className = "mb-1"

                  var status = document.createElement("span");
                  status.id = url + "_status";
                  status.className = "ml-3 lspinner";
                  status.innerText = "..."

                  li.appendChild(status);

                  ul.appendChild(li);
                }

                function setStatus(url, error) {
                  var status = document.getElementById(url + "_status");
                  var classes = "ml-3 fa fa-check text-success";
                  if (error) {
                    classes = "ml-3 fa fa-circle-xmark text-danger";
                    status.title = error;
                  }
                  status.innerText = "";
                  status.className = classes;
                }
        `;
    var html = `

              <div class="container-fluid p-4" id="uxStatusContainer"> 
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <h2>Closing sessions ... <span id="uxCountdown"></span></h2>
                    </div>
                    <div class="row">
                      <ul id="uxUrls" class="url">
                      </ul>
                    </div>
                    <div class="row">
                      <h3 id="uxLog"></h3>
                    </div>

                  </div>
                </div> 
              </div>
`;
    //return new Promise((s, e) => {
    let link = document.createElement("link");
    link.href = "https://sso-dev.matrixcare.me/neo/css/neo.min.css";
    link.rel = "stylesheet";
    //document.head.appendChild(link);
    let script = document.createElement("script");
    script.innerHTML = scriptCode;
    document.head.appendChild(script);
    let style = document.createElement("style");
    style.innerHTML = styleCode;
    document.head.appendChild(style);
    let meta = document.createElement("meta");
    meta.name = "viewport";
    meta.content = "width=device-width, initial-scale=1";
    document.head.appendChild(meta);
    document.body.innerHTML = html;
    document.title = "Resmed IDM Logout";
    //s(null);
    //})
  }
  //Will generate the require UI to display the progress of the logouts
  configureLogoutStatusUI() {
    var preview = this.utilities.getQueryVariable("preview");
    //if (cookieArray && cookieArray.length>1) {
    this.renderStatusHtml();
    //}
    this.statusChanged = (url, error) => {
      window["setStatus"](url, error);
    };
    var firstAdded = true;
    var timeout = this.timeout;
    this.urlAdded = url => __awaiter(this, void 0, void 0, function* () {
      if (firstAdded) {
        firstAdded = false;
        document.getElementById("uxCountdown").innerText = timeout + "s left.";
        var interval = setInterval(() => {
          timeout--;
          document.getElementById("uxCountdown").innerText = timeout + "s left.";
          if (timeout == 0) {
            clearInterval(interval);
          }
        }, 1000);
      }
      window["addUrl"](url);
    });
    if (preview) {
      var urls = ["https://www.bing.com", "https://www.google.com", "https://www.matrixcare1.com", "https://www.matrixcare2.com", "https://www.matrixcare3.com", "https://www.matrixcare4.com", "https://www.matrixcare5.com", "https://www.matrixcare6.com", "https://www.matrixcare7.com", "https://www.matrixcare8.com", "https://www.matrixcare9.com", "https://www.matrixcare10.com", "https://www.matrixcare11.com", "https://www.matrixcare12.com", "https://www.matrixcare13.com", "https://www.matrixcare14.com", "https://www.matrixcare15.com"];
      for (let url of urls) {
        this.urlAdded(url);
      }
      let i = 0;
      let timer = setInterval(() => {
        if (i == urls.length - 1) {
          clearInterval(timer);
        }
        this.statusChanged(urls[i], "");
        i++;
      }, 250);
      return;
    }
  }
  logout(loginServiceUrl, redirectTo, app, configId, authPerCustomer, crmId) {
    return __awaiter(this, void 0, void 0, function* () {
      this.utilities.writeCookie("lastActivity", new Date(1900, 0, 1).toString(), null, true);
      const logoutInProgressCookieName = "mx1.logout-in-progress";
      var storedRedirect = this.utilities.readCookie(logoutInProgressCookieName);
      if (!storedRedirect) {
        console.log("performing server session logout ...");
        let defaultExpiration = 10; //lets assume each logout request takes x seconds. So the cookie is auto removed to not cause trouble if the cookie is not removed becuase of logout errors
        var mcCheck = this.utilities.readCookie(this.CookieName);
        var cookieArray = null;
        if (mcCheck) {
          cookieArray = mcCheck.split(',');
          defaultExpiration = cookieArray.length * defaultExpiration;
        }
        this.utilities.writeCookie(logoutInProgressCookieName, redirectTo, defaultExpiration, false);
        this.configureLogoutStatusUI();
        yield this.commonLogout(redirectTo);
        console.info(`deleting #2 ${logoutInProgressCookieName}`);
        this.utilities.deleteCookie(logoutInProgressCookieName);
        var url = `${loginServiceUrl}/api/auth/logout?app=${app}&configId=${configId}&crmId=${crmId}&authPerCustomer=${authPerCustomer}&redirectTo=${encodeURIComponent(redirectTo)}`;
        window.location.href = url;
        return;
      } else {
        window.location.href = redirectTo;
      }
      //else {
      //    console.log("performing common logout ...");
      //    await this.commonLogout(redirectTo);
      //}
    });
  }
  commonLogout(redirectTo) {
    console.log(`commonLogout redirectTo:${redirectTo},  origin:${window.location.origin}`);
    if (!redirectTo) {
      console.error("You must suply the redirectTo parameter");
    }
    var promise = new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
      try {
        var cookieName = this.CookieName;
        let utility = new IdmUtilities();
        var selfLogoutUrl = utility.readCookie("mx1.selfLogout"); //this is the local cookie created when self registering the logout url.
        let currentCookie = this.utilities.readCookie(cookieName);
        console.log(`MCCheck Cookie:${currentCookie}`);
        if (currentCookie != null && currentCookie != "null") {
          var cookieArray = currentCookie.split(',');
          if (cookieArray != null) {
            var logoutUrls = cookieArray;
            const index = logoutUrls.indexOf(selfLogoutUrl);
            if (index > -1) {
              // only splice array when item is found
              logoutUrls.splice(index, 1); // 2nd parameter means remove one item only
            }
            var promises = new Array();
            for (let logoutUrl of logoutUrls) {
              console.log(`Processing ${logoutUrl}. mx1.selfLogout:${selfLogoutUrl}`);
              try {
                console.info(`IFRAME: Loading ${logoutUrl} ...`);
                var p = this.loadInIframe(logoutUrl);
                this.removeLogoutUrl(logoutUrl);
                promises.push(p);
              } catch (e) {
                console.error("IFRAME: Loading error", e);
              }
            }
            try {
              yield Promise.all(promises);
            } catch (e) {
              console.error(e);
            }
            this.utilities.deleteCookie(this.CookieName, true);
          }
        } else {}
        this.utilities.writeCookie("lastActivity", new Date(1900, 0, 1).toString(), null, true);
        //var url = redirectTo;
        //window.location.href = url;
        resolve(null);
      } catch (e) {
        console.error(e);
      }
    }));
    return promise;
  }
  loadInIframe(url) {
    return new Promise((resolve, reject) => {
      var _a;
      var iframe = document.createElement("iframe");
      iframe.src = url;
      iframe.style.display = "none";
      iframe.width = "0";
      iframe.height = "0";
      var timeout;
      //yes. one event listener for iframe so I can inspect the origin
      //this is so we don't wait "timeout" seconds. If the product is using the shared login, we will receive a message once the login completes and the go the the login screen
      // if the don't once logout is completed, the should call window.parent.postMessage("shared-login-loaded",  "*");
      window.addEventListener("message", ev => {
        //console.info(`onmessage ${ev.data} ${url} ${ev.origin} ${ev.data?.host}`);
        var _a, _b, _c, _d;
        if (((_a = ev.data) === null || _a === void 0 ? void 0 : _a.message) != "shared-login-logout-completed")
          //we only care about the message sent fromthe login screen
          return;
        if (url != ((_b = ev.data) === null || _b === void 0 ? void 0 : _b.host))
          //not interested in other domains that the one on the url called
          return;
        console.log(`logout event received from ${ev.origin} ${(_c = ev.data) === null || _c === void 0 ? void 0 : _c.host}`);
        (_d = this.statusChanged) === null || _d === void 0 ? void 0 : _d.call(this, url, "");
        clearTimeout(timeout);
        resolve(null);
      });
      iframe.addEventListener("error", e => {
        var _a;
        (_a = this.statusChanged) === null || _a === void 0 ? void 0 : _a.call(this, url, e);
        console.error("loadInIframe", e);
        reject(e);
      });
      iframe.addEventListener("load", () => {
        timeout = setTimeout(() => {
          var _a;
          document.body.removeChild(iframe);
          (_a = this.statusChanged) === null || _a === void 0 ? void 0 : _a.call(this, url, "");
          resolve(null);
        }, this.timeout * 1000);
      });
      (_a = this.urlAdded) === null || _a === void 0 ? void 0 : _a.call(this, url);
      document.body.appendChild(iframe);
    });
  }
}
